module.exports = __webpack_public_path__ + "img/index_pic2.957dc678.png";